import React from 'react'
import sizeMe from 'react-sizeme'
import ConfirmShippedDialog from './ConfirmShippedDialog'
import { compose } from 'recompose'

import {
    Card,
    CardActions,
    CardContent,
    CardMedia,
    Button,
    Typography,
    Avatar,
    Grid,
    Divider
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

const styles = {
    itemAvatar: {
        width: 20,
        height: 20
    }
};

const Item = ({ item, size: { width, height }, onShippingLabelCreate, onConfirmItemShipped }, classes) => {


    const photo = item.get("photos")[0]
    const itemPhotoURL = photo.get("photo")._url
    const factor = Math.min(photo.get("width") / width, width / photo.get("width"))
    const transactionStatus = item.get("transactionStatus")
    const buyer = item.get("soldTo")
    const buyerAddress = buyer.get("userAddress")
    const buyerName = buyer.get("firstName") + " " + buyer.get("lastName")
    var buyerAvatarURL = null

    if (buyer.get("profilePicture")._url) {
        buyerAvatarURL = buyer.get("profilePicture")._url
    }




    return (
        <div>
            {item ? (
                <Card>
                    <CardMedia style={{ height: photo.get("height") * factor, width: width }}
                        image={itemPhotoURL}
                        title={item.get("brand")}>
                    </CardMedia>

                    <CardContent>
                        <Typography variant="headline" color="inherit">
                            {item.get("brand")}
                        </Typography>
                        <Typography gutterBottom variant="caption">
                            {item.get("size")}
                        </Typography>
                        {item.get("brandNew") === true ? <Typography gutterBottom variant="caption">Brand New</Typography> : null}
                        <Typography gutterBottom variant="body2">
                            {item.get("serialNumber")}
                        </Typography>
                        <Typography component="p">
                            {item.get("details")}
                        </Typography>
                    </CardContent>
                    <Divider light />
                    <CardContent>
                        <Grid container direction="row" spacing={8} alignItems="center" alignContent="center">
                            <Grid item>
                                {buyerAvatarURL ?
                                    <Avatar src={buyerAvatarURL}
                                        alt={buyerName} /> : null}
                            </Grid>
                            <Grid item>
                                <Grid container direction="column" spacing={0}>
                                    <Grid item>
                                        <Typography variant="subheading">{buyerName}</Typography>

                                    </Grid>
                                    <Grid item>
                                        <Typography variant="caption">{
                                            buyerAddress.get("street") + ", " +  buyerAddress.get("city") + ", " + buyerAddress.get("state")
                                        }</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <Divider light />
                    <CardActions>
                        {transactionStatus === "CREATE_SHIPPING_LABEL" ? (
                            <Button
                                color="primary"
                                variant="raised"
                                fullWidth={true}
                                onClick={event => onShippingLabelCreate(item)}>
                                Generate shipping label
                            </Button>
                        ) : (
                                <div>
                                    <ConfirmShippedDialog item={item} onConfirmItemShipped={onConfirmItemShipped} />
                                    <br />
                                    <Button size="small"
                                        href={item.get("checkoutInfo") ? item.get("checkoutInfo").get("shippingLabelShortenURL") : null}
                                        target="_blank"
                                        variant="flat"
                                        color="secondary">
                                        View shipping label
                                     </Button>
                                </div>
                            )}

                    </CardActions>
                </Card>
            ) : null}
        </div>
    )
}

export default compose(
    withStyles(styles),
    sizeMe({ monitorHeight: true })
)(Item)





// WEBPACK FOOTER //
// ./src/components/Item.js